/**
 * Version de l'application — affichée dans l'UI (page de login).
 *
 * Schéma : V{sprint}.{push}.{client}
 * - sprint : numéro du sprint (ajout fonctionnel). Reste stable pendant un sprint.
 *            Incrémenter au début de chaque nouveau sprint.
 *            V2 = sprint courant (inclut la migration Vite+Hono, non prévue initialement).
 *            V3 = prochain sprint.
 * - push   : numéro du push GitHub depuis le début du sprint courant.
 *            Redémarre à 1 à chaque changement de sprint (Vx).
 *            Incrémenter à chaque push vers origin/main.
 * - client : nombre cumulé de changements visibles client depuis le début du
 *            sprint courant (pas depuis le dernier push).
 *            Exemples de changements visibles : pin plus gros, bouton plus bas,
 *            chargement plus rapide, debug sync visible client, correction visuelle…
 *            Ne redescend JAMAIS tant qu'on reste sur le même sprint Vx.
 *            Redémarre à 0 uniquement au changement de sprint.
 *            Un push purement technique (doc, refacto invisible) laisse .M inchangé.
 *
 * Incrémenter manuellement à chaque release.
 */
export const APP_VERSION = "2.6.3";
